export const EXPLORE_TAB_TOUCHPOINT = 'ppshopping_explore_tab_layout'
export const SAVED_TAB_TOUCHPOINT = 'ppshopping_saved_tab_layout'
